module.exports = __webpack_public_path__ + "img/brand_07.0f329be9.png";